export enum FeedActionKeys {
    FEED_GET_REQUEST = '@@feed/FETCH_REQUEST',
    FEED_GET_FAILURE = '@@feed/FETCH_FAILURE',
    FEED_GET_SUCCESS = '@@feed/GET_SUCCESS',
    FEED_RESET = '@@feed/RESET',
    FEED_ADD_DATA = '@@feed/UPDATE_ADD_DATA',
    FEED_UPDATE_DATA = '@@feed/UPDATE_UPDATE_DATA',
    FEED_REPLACE_DATA = '@@feed/UPDATE_REPLACE_DATA',
    FEED_DELETE_DATA = '@@feed/DELETE_DATA',
    FEED_TRY_UPDATE_PUBLICATION = '@@feed/TRY_UPDATE_PUBLICATION',
    FEED_TRY_DELETE_PUBLICATION = '@@feed/TRY_DELETE_PUBLICATION',
    FEED_EXECUTING_ACTION = '@@feed/EXECUTING_ACTION',
    FEED_CLEARDATA = "FEED_CLEARDATA"
}
